module.exports = __webpack_public_path__ + "img/cs.591673ee.svg";